import { DSNCFeedback, DSResource } from 'shared-definitions/types'
import { ApiComponent, ApiComponentFeedbackForm } from 'data-source/types.wp'

interface FeedbackOpts<T extends DSResource, A extends ApiComponent> {
  componentItemMapper: (input: A) => T | T[]
}

export function ncFeedback<T extends DSResource, A extends ApiComponent>(
  input: ApiComponentFeedbackForm<A>,
  opts: FeedbackOpts<T, A>
): DSNCFeedback<T> {
  return {
    resource: 'nc-feedback',
    responseLimit: input.max_character_count ?? 2500,
    question: input.question,
    positive: {
      msg: input.submitted,
      blocks: input.additional_onsubmit_content_positive_feedback.flatMap(opts.componentItemMapper),
    },
    negative: {
      question: input.feedback_question,
      variants: input.feedback_variants,
      otherVariant: input.other_variant_label,
      placeholder: input.other_variant_placeholder,
      button: input.submit_label,
      blocks: input.additional_onsubmit_content_negative_feedback.flatMap(opts.componentItemMapper),
    },
  }
}
